import { createEffect, createSignal } from "solid-js";
import { LoadingButton } from "../../components/ui/Button";
import { TextInput } from "../../components/ui/form/TextInput";
import ImageUploader from "@/components/ui/ImageUploader";;
import { Modal } from "../../components/ui/Modal";
import { DialogFooter } from "@/components/shadcn/dialog";
import useTestForm from "../../services/useTestForm";

export const TestModal = (props) => {

  const [open, setOpen] = createSignal(false);
  const [title, setTitle] = createSignal('');
  const onClose = (state) => {
    if (typeof props.onClose === 'function') {
      props.onClose();
    }
  }

  const onRefresh = () => {
    if (typeof props.onRefresh === 'function') {
      props.onRefresh();
    }
  }

  const {
    form,
    handleInput,
    handleChange,
    handleSave,
    fetchInfo,
    loading,
    fetching,
    clearForm,
  } = useTestForm({ onClose, onRefresh });

  createEffect(() => {
    props.open;
    setOpen(props.open);
  });

  createEffect(() => {
    props.key;
    if (props.key !== null) {
      fetchInfo(props.key);
      setTitle('Edit Test');
    } else {
      clearForm();
      setTitle('New Test');
    }
  });

  return (
    <Modal
      open={open()}
      title={title()}
      onClose={onClose}
      fetching={fetching()}
      hideOnOutsideClick={false}
      error={''}
    >
      <div class="grid gap-2">
        <div class="grid gap-1">
          <TextInput
            label="Name"
            name="name"
            form={form}
            input={handleChange}
          />
        </div>
        <div class="grid gap-1">
          <TextInput
            label="Result Options"
            name="results"
            form={form}
            input={handleChange}
          />
        </div>
      </div>
      <DialogFooter>
        <LoadingButton variant="outline" onClick={() => { handleSave() }} type="button" loading={loading()} disabled={fetching()}>Save</LoadingButton>
      </DialogFooter>
    </Modal>
  );
}
